import React from "react";
import "./Founder.css";
import founder from "../../Assets/Founder/WhatsApp Image 2026-06-24 at 16.41.56.jpeg";
import Host from "../../Host/Host";

const Founder = ({ data }) => {
  return (
    <section className="Founder">
      <div className="Founder-container landing-pages">
        <div className="Founder-box">
          {/* LEFT CONTENT */}
          <div className="Founder-left">
            <p className="founder-subtitle">{data?.founderSubtitle}</p>

            <h2 className="founder-title">
              {data?.founderTitle?.split(" ").slice(0, -3).join(" ")}
              <span> {data?.founderTitle?.split(" ").slice(-3).join(" ")}</span>
            </h2>

            {/* <p className="founder-desc"> */}
            {data?.founderDescription?.map((block, index) => {
              // helper for inline formatting
              const renderChildren = (children) =>
                children?.map((child, i) => {
                  let text = child.text;

                  if (child.bold) {
                    text = <strong key={i}>{text}</strong>;
                  }

                  if (child.italic) {
                    text = <em key={i}>{text}</em>;
                  }

                  if (child.underline) {
                    text = <u key={i}>{text}</u>;
                  }

                  if (child.strikethrough) {
                    text = <s key={i}>{text}</s>;
                  }

                  if (child.code) {
                    text = <code key={i}>{text}</code>;
                  }

                  // links
                  if (child.type === "link") {
                    return (
                      <a
                        key={i}
                        href={child.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {child.children?.map((c) => c.text).join("")}
                      </a>
                    );
                  }

                  return <React.Fragment key={i}>{text}</React.Fragment>;
                });

              // headings
              if (block.type === "heading") {
                switch (block.level) {
                  case 1:
                    return (
                      <h1 key={index}>{renderChildren(block.children)}</h1>
                    );
                  case 2:
                    return (
                      <h2 key={index}>{renderChildren(block.children)}</h2>
                    );
                  case 3:
                    return (
                      <h3 key={index}>{renderChildren(block.children)}</h3>
                    );
                  case 4:
                    return (
                      <h4 key={index}>{renderChildren(block.children)}</h4>
                    );
                  case 5:
                    return (
                      <h5 key={index}>{renderChildren(block.children)}</h5>
                    );
                  case 6:
                    return (
                      <h6 key={index}>{renderChildren(block.children)}</h6>
                    );
                  default:
                    return null;
                }
              }

              // paragraph
              if (block.type === "paragraph") {
                return (
                  <p className="founder-desc" key={index}>
                    {renderChildren(block.children)}
                  </p>
                );
              }

              // unordered / ordered list
              if (block.type === "list") {
                const ListTag = block.format === "ordered" ? "ol" : "ul";

                return (
                  <ListTag key={index}>
                    {block.children?.map((item, idx) => (
                      <li key={idx}>
                        {item.children?.map((child, i) => (
                          <React.Fragment key={i}>{child.text}</React.Fragment>
                        ))}
                      </li>
                    ))}
                  </ListTag>
                );
              }

              // quote
              if (block.type === "quote") {
                return (
                  <blockquote key={index}>
                    {renderChildren(block.children)}
                  </blockquote>
                );
              }

              // code block
              if (block.type === "code") {
                return (
                  <pre key={index}>
                    <code>{block.children?.map((c) => c.text).join("")}</code>
                  </pre>
                );
              }

              return null;
            })}
            {/* </p> */}

            <p className="founder-sign">{data?.founderName}</p>
          </div>

          <div className="Founder-right">
            <div className="image-blob">
              <img src={data?.founderImage?.url} alt="founder" />
            </div>
          </div>
        </div>
        <div className="director-box">
          <div className="director-right">
            <div className="image-blob">
              <img src={founder} alt="director" />
            </div>
          </div>
          <div className="director-left">
            <p className="founder-subtitle">— Our Managing Director</p>
            <p className="founder-desc">
              We are pleased to announce the appointment of Mrs. Hayat Titus as
              our Managing Director. With over 35 years of international
              experience spanning Dubai and Los Angeles, she brings exceptional
              leadership, industry expertise, and a global perspective to our
              organization. We look forward to her guidance as we continue our
              journey of growth, innovation, and excellence.
            </p>
            <p className="founder-sign">— Mrs. Hayat Titus</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Founder;
